import React from 'react';
import './ConfirmModal.css';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'OK',
  cancelText = 'キャンセル',
  isProcessing = false,
  processingText = '処理中...',
}) => {
  if (!isOpen) {
    return null;
  }

  const handleConfirm = (e) => {
    e.preventDefault();
    onConfirm();
  };

  return (
    <div className="confirm-modal-overlay" onClick={onClose}>
      <div className="confirm-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-modal-header">
          <h2>{title}</h2>
        </div>
        <div className="confirm-modal-body">
          <p>{message}</p>
        </div>
        <div className="confirm-modal-actions">
          <button type="button" onClick={onClose} className="btn-cancel" disabled={isProcessing}>
            {cancelText}
          </button>
          <button type="button" onClick={handleConfirm} className="btn-confirm" disabled={isProcessing}>
            {isProcessing ? processingText : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
